<div id="portalOneContainer"></div>
<div class="page-content">
    <app-main-menu></app-main-menu>
    <app-cookie-component></app-cookie-component>
    <router-outlet></router-outlet>
    <span *ngIf="showLoader" class="custom-loading">
    <span class="spinner-container">
      <div class="sp sp-slices"></div>
    </span>
  </span>
</div>
